import { useEffect } from "react";
import Toast from "react-bootstrap/Toast";
import "./SelectEmployee.css";
export default function EmployeeDeleteToast(props) {
  const {
    message = "No message to show",
    show,
    delay = 1000,
    onClose,
    autohide,
  } = props || {};

  useEffect(() => {
    const closeToast = () => {
      if (autohide) {
        setTimeout(() => {
          onClose();
        }, [delay]);
      }
    };

    return () => {
      clearTimeout(closeToast);
    };
  }, [show, autohide]);

  if (!show) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: "3rem",
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Toast
        show={show}
        onClose={onClose}
        autohide={autohide}
        className="shadow-success p-3 mb-5 bg-body rounded"
      >
        <Toast.Header className="d-flex flex-row-reverse bg-transparent"></Toast.Header>
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    </div>
  );
}
